import { getContractBasedDataSelector } from '@cp-shared-10/frontend-integration';
import { RootState } from 'store/rootReducer';

export const PaymentOverviewDataSelector = getContractBasedDataSelector((state: RootState) => state.paymentOverview);
